export var ResearchBranch;
(function (ResearchBranch) {
    ResearchBranch["ECONOMY"] = "ECONOMY";
    ResearchBranch["MILITARY"] = "MILITARY";
})(ResearchBranch || (ResearchBranch = {}));
export var ResearchType;
(function (ResearchType) {
    // Economy branch
    ResearchType["CONSERVATION"] = "CONSERVATION";
    ResearchType["PULLEY"] = "PULLEY";
    ResearchType["CARTOGRAPHY"] = "CARTOGRAPHY";
    ResearchType["TAXATION"] = "TAXATION";
    ResearchType["IRRIGATION"] = "IRRIGATION";
    // Military branch
    ResearchType["BRONZE_ARMOR"] = "BRONZE_ARMOR";
    ResearchType["SHARPENED_BLADES"] = "SHARPENED_BLADES";
    ResearchType["FORMATIONS"] = "FORMATIONS";
    ResearchType["SIEGE_CRAFT"] = "SIEGE_CRAFT";
    ResearchType["NAVAL_WARFARE"] = "NAVAL_WARFARE";
})(ResearchType || (ResearchType = {}));
//# sourceMappingURL=research.js.map